import { HttpErrorResponse } from '@angular/common/http';
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { GlobalService } from '../../../services/global.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { WebformService } from '../../../services/webform.service';

@Component({
    selector: 'app-engagepost-webform',
    templateUrl: './engagepost-webform.component.html',
    styleUrls: ['./engagepost-webform.component.css']
})
/** engagepost-webform component*/
export class EngagePostWebformComponent implements OnInit {
    wfid: any;
    cid: any;
    htmlText: any;
    private destroy$ = new Subject<void>();

    /** engagepost-webform ctor */
    constructor(
        private webformService: WebformService,
        private _utilityService: UtilityService,
        private _route: ActivatedRoute,
        private _globalService: GlobalService
    ) {

    }

    ngOnInit() {
        this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(async params => {
            if (params.wfid) {
                this.wfid = params.wfid
            }
            if (params.cid) {
                this.cid = params.cid
            }

            this.getSOPOSTWebForm()
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async getSOPOSTWebForm() {
        await this.webformService.getSOPOSTWebForm(this.wfid, this.cid)
            .then(async (result: any) => {
                if (!isNullOrUndefined(result)) {
                    this.htmlText = result?.message
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("tectMsgTemplate.authenticateR", err.message, null, 'wfid ' + this.wfid + 'cid ' + this.cid);
                this._utilityService.handleErrorResponse(err);
            });
    }
}
